import { blogPosts1 } from './blogPosts1';
import { blogPosts2 } from './blogPosts2';
import { blogPosts3 } from './blogPosts3';
import { blogPosts4 } from './blogPosts4';
import { blogPosts5 } from './blogPosts5';
import { blogPosts6 } from './blogPosts6';

const allPosts = [
  ...blogPosts1,
  ...blogPosts2,
  ...blogPosts3,
  ...blogPosts4,
  ...blogPosts5,
  ...blogPosts6,
].sort((a, b) => new Date(b.date) - new Date(a.date));

export const getAllPosts = () => allPosts;

export const getRecentPosts = (count = 6) => allPosts.slice(0, count);

export const getPostBySlug = (slug) => allPosts.find((p) => p.slug === slug);

export const getPostsByCategory = (category) =>
  allPosts.filter((p) => p.category === category);
